module.exports = __webpack_public_path__ + "media/images/sample/product-6-f9c3f15914458e78fc6a0462ec0fef39.png";